import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import DeActStaff from './DeActStaff';


const DeActProfile = () => {
  const [userData, setUserData] = useState(null); 
  const [showDeActStaff, setShowDeActStaff] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const additionalCustomerId = useSelector((state) => state.auth.additionalCustomerId);
  const token = useSelector((state) => state.auth?.user?.token) || localStorage.getItem('accessToken');
  const apiUrl = process.env.REACT_APP_API_URL;

  useEffect(() => {
    const fetchUserData = async () => {
      
      const customerId = additionalCustomerId?.customerId;  
      console.log('Customer ID:', customerId); 
      if (customerId) {
        try {
           const response = await axios.get(`${apiUrl}/account/deactivate/useraccountdetails?customerId=${customerId}`,
            // const response = await axios.get(`${apiUrl}/account/deactivate/useraccountdetails?customerId=33`,
            {
              headers: {
                Authorization: `Bearer ${token}`,
              },
            }
          );
          setUserData(response.data);  
        } catch (error) {
          console.error('Error fetching user details:', error);
          alert('Failed to fetch user details. Please try again later.');
        }
      } else {
        console.error('Customer ID is missing!');
        alert('Customer ID is missing. Please try again later.');
      }
    };
  
    if (additionalCustomerId) {
      fetchUserData();
    }
  }, [additionalCustomerId, apiUrl, token]);

  const handleDeactivateClick = () => {
    setShowPopup(true);
  };

  const handleProceedClick = () => {
    setShowPopup(false);
    setShowDeActStaff(true);
  };

  const handleCancelClick = () => {
    setShowPopup(false);
  };

  if (showDeActStaff) {
    return <DeActStaff />;
  }

  return (
    <div className="close-use-out">
      <div className="close-use-cont">Deactivate a User Account</div>

      {userData ? (
        <div className="de-act-cont">
          <div className="de-act-cont-grp">
            <div className="profile-out-cont-deact">
              <FontAwesomeIcon icon={faUser} className="profile-icon-deact" />
            </div>
            <div className="de-act-id-cont">
              <div className="de-act-entry">
                <h5>User Name</h5>
                <p>{userData.userName}</p>
              </div>
              <div className="de-act-entry">
                <h5>Name</h5>
                <p>{userData.name}</p>
              </div>
              <div className="de-act-entry">
                <h5>Mobile Number</h5>
                <p>{userData.mobileNumber}</p>
              </div>
              <div className="de-act-entry">
                <h5>Customer ID</h5>
                <p>{userData.customerId}</p>
              </div>
              <div className="de-act-entry">
                <h5>Scheme Enrolled</h5>
                <p>{userData.schemesEnrolled}</p>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <p>Loading user details...</p>
      )}

      <button className="close-proceed" onClick={handleDeactivateClick}>
        Deactivate Account
      </button>

      {showPopup && (
        <div className="popup-overlay">
          <div className="popup-mem-sch">
            <div className="popup-content-mem-sch">
              <p>Are you sure you want to deactivate and close this user’s account?</p>
              <div className="popup-buttons-mem-sch">
                <button className="popup-btn-mem-sch proceed-btn-mem-sch" onClick={handleProceedClick}>
                  Proceed
                </button>
                <button className="popup-btn-mem-sch cancel-btn-mem-sch" onClick={handleCancelClick}>
                  Cancel
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DeActProfile;
